import {CommentThreadAnchorType} from "@buildwithflux/models";

import {currentAgentIsBot} from "../../../../../helpers/isBot";
import type {DocumentSelector, DocumentStoreState} from "../types";
import {emptyArray} from "../utils";

/**
 * Derived selectors for comment threads - computed values
 */

/** Counts unresolved PCB comment threads */
export const unresolvedPcbCount: DocumentSelector<number> = (state: DocumentStoreState) => {
    const commentThreads = state.comment_threads;
    if (!commentThreads) return 0;
    let count = 0;
    for (const thread of Object.values(commentThreads)) {
        if (thread.anchor.type === CommentThreadAnchorType.pcb2d_position && !thread.resolved) {
            count++;
        }
    }
    return count;
};

/** Counts unresolved schematic comment threads */
export const unresolvedSchematicCount: DocumentSelector<number> = (state: DocumentStoreState) => {
    const commentThreads = state.comment_threads;
    if (!commentThreads) return 0;
    let count = 0;
    for (const thread of Object.values(commentThreads)) {
        if (thread.anchor.type === CommentThreadAnchorType.position && !thread.resolved) {
            count++;
        }
    }
    return count;
};

/** Gets UIDs of PCB 2D comment threads */
export const pcb2dUids: DocumentSelector<string[]> = (state: DocumentStoreState) => {
    const commentThreads = state.comment_threads;
    if (!commentThreads) return emptyArray;
    const result: string[] = [];
    for (const commentThread of Object.values(commentThreads)) {
        if (commentThread.anchor.type === CommentThreadAnchorType.pcb2d_position) {
            result.push(commentThread.uid);
        }
    }
    return result;
};

/**
 * Gets UIDs of pinned schematic comment threads.
 * Note: Shows all comment threads to crawlers for SEO purposes
 */
export const pinnedSchematicUids: DocumentSelector<string[]> = (state: DocumentStoreState) => {
    const commentThreads = state.comment_threads;
    if (!commentThreads) return emptyArray;
    const result: string[] = [];
    for (const commentThread of Object.values(commentThreads)) {
        // show all comment threads to crawlers so they help with SEO
        if (
            commentThread.anchor.type === CommentThreadAnchorType.position &&
            (commentThread.pinned || currentAgentIsBot)
        ) {
            result.push(commentThread.uid);
        }
    }
    return result;
};
